<script lang="ts" setup>
  const props = defineProps<{
    name: string;
    mode?: 'svg' | 'css';
    size?: string | number;
    customize?: (content: string, name?: string, prefix?: string, provider?: string) => string;
  }>();
  const attrs = useAttrs();
  const uiPayload = computed(() => ({ ...attrs, ...props }));
</script>

<template>
  <UIcon class="size-6" v-bind="uiPayload" />
</template>
